'use client';
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const { currentPost, postsBasePath } = useLoadPostBySlug("siab");


    return (
        <PostContentFallback>
            <article>
                {currentPost && (
                    <div style={{ backgroundImage: `url(${currentPost.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                        <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                            <SectionPage sectionType={"2xl"}>
                                <h1 className={"text-white text-4xl font-exo"}>{currentPost.title}</h1>
                            </SectionPage>
                        </div>
                    </div>
                )}

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <h1 className="text-3xl font-bold font-exo text-rose mt-8 mb-4">
                            « Les artisans sont l’âme de la Côte d’Ivoire » <br /><br />
                            Côte d’Ivoire Tourisme place l’artisanat au cœur de sa stratégie
                        </h1>


                        <p className="my-4 text-normal leading-relaxed">
                            Les lampions se sont éteints ce Lundi 07 Août sur l’édition 2023 de la Semaine Internationale de l’Artisanat de Grand – Bassam, organisée par la Fondation SIAB.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            A la veille de cette clôture, la Directrice Générale de Côte d’ivoire de Côte d’Ivoire Tourisme s’est rendue sur le site afin d’exprimer à l’organisation toute la fierté qu’elle éprouve à l’idée de voir le pays accueillir des artisans issus de la sous – région, à la faveur de cet évènement. Madame Malékah MOURAD-CONDE a également tenu à exprimer son soutien aux artisans car pour cette année 2023, Côte d’Ivoire Tourisme marque un point d’honneur à l’Artisanat d’art. En effet, pour la Directrice Générale de l’Office, les artisans sont l’âme de la Côte d’Ivoire car ils permettent de pérenniser la culture et les souvenirs que des visiteurs peuvent garder du pays. Ils participent également selon, elle, au développement de l’éco – système du tourisme mais aussi à la lutte contre la pauvreté en milieu rural à travers la commercialisation de leurs œuvres.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            A cet égard, Madame Malékah MOURAD-CONDE s’est dite particulièrement impressionnée par les artisanes qui transforment le coton bio en produits destinés à la vente.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Profondément ému par cette marque d’attention de la Directrice Générale de Côte d’Ivoire Tourisme, le Commissaire Général de l’évènement s’est réjoui du taux de participation des exposants. Monsieur Ali CISSE dénombre 710 participants pour 368 stands occupés.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Plusieurs innovations ont marqué la SIAB cette année, notamment des expositions, des défilés de mode, des conférences, des vernissages, des prestations de danses traditionnelles et un diner gala.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Cette année, la semaine internationale a exploré le thème « L’Artisanat, moteur de l’économie africaine ».
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            A cet effet, la SIAB ambitionne de mieux positionner les artisans africains sur le marché international, indique son Commissaire Général Monsieur Ali CISSE.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Pour sa part, Côte d’Ivoire Tourisme renforcera son appui à l’évènement.
                        </p>
                    </div>


                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 4 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/gallerie/${index + 1}.png`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-4 gap-4"} />
                    </div>

                    {currentPost && <SimilarPosts currentSlug={currentPost.slug} />}
                </SectionPage>
            </article>
        </PostContentFallback>

    );
}
